!(function () {
    "use strict";
    class t extends HTMLElement {
        constructor() {
            super(),
                (this.section = this.closest("product-info")),
                (this.form = this.section.querySelector("[data-product-form]")),
                (this.formWrapper =
                    (theme.settings.productPageSticky && this.section.querySelector("[data-form-wrapper]")) ||
                    this.form),
                (this.handleProductAddError = this.handleProductAddError.bind(this)),
                (this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this)),
                (this.boundSetCartBarHeight = this.setCartBarHeight.bind(this));
        }
        connectedCallback() {
            this.setCartBarHeight(),
                this.addEventListener("click", this.handleClick.bind(this)),
                document.addEventListener("theme:resize", this.boundSetCartBarHeight),
                document.addEventListener("theme:product:add-error", this.handleProductAddError);

            this.mainButton = this.form && this.form.querySelector('[name="add"]');
            this.mainButtonVisible = false;

            if (this.mainButton && "IntersectionObserver" in window) {
                this.observer = new IntersectionObserver(
                    ([entry]) => {
                        this.mainButtonVisible = entry.intersectionRatio >= 0.99;
                        this.updateVisibility();
                    },
                    { threshold: [0, 0.99] }
                );
                this.observer.observe(this.mainButton);
            } else {
                document.addEventListener("theme:scroll", this.boundToggleCartBarOnScroll);
            }

            if (window.subscribe && theme.PUB_SUB_EVENTS) {
                this.variantChangeUnsubscriber = subscribe(
                    theme.PUB_SUB_EVENTS.variantChange,
                    this.handleVariantChange.bind(this)
                );
            }
        }
        handleVariantChange({ data }) {
            const sectionId = this.section.dataset.originalSection || this.section.dataset.section;
            if (data.sectionId !== sectionId) return;

            const button = this.querySelector(".product__submit__add");
            const text = button && button.querySelector(".btn__text");
            if (!text) return;

            button.removeAttribute("data-cart-bar-scroll");
            button.setAttribute("data-cart-bar-add-to-cart", "");

            if (data.variant && data.variant.available) {
                button.removeAttribute("disabled");
                text.textContent = this.section.isPreorder ? theme.strings.preOrder : theme.strings.addToCart;
            } else {
                button.setAttribute("disabled", "disabled");
                text.textContent = theme.strings.soldOut;
            }
        }
        updateVisibility() {
            this.classList.toggle("is-visible", !this.mainButtonVisible);
        }
        handleClick(t) {
            const e = t.target.closest("[data-cart-bar-add-to-cart]");
            e &&
                (t.preventDefault(),
                e.classList.add("is-loading"),
                e.setAttribute("disabled", "disabled"),
                this.form.closest("product-form").onSubmitHandler(t)),
                t.target.closest("[data-cart-bar-scroll]") && (t.preventDefault(), this.scrollToTop());
        }
        handleProductAddError() {
            this.querySelector("[data-cart-bar-add-to-cart]") && this.scrollToTop();
        }
        scrollToTop() {
            const target =
                this.section.querySelector("variant-selects") ||
                this.form;
            const t = target.getBoundingClientRect().top;
            if (theme.isMobile && this.mainButton) {
                const header = document.querySelector("[data-header-sticky]") ? document.querySelector("[data-header-height]").offsetHeight : 0;
                const toSelects = t + window.scrollY - header - 30;
                const toButton = this.mainButton.getBoundingClientRect().bottom + window.scrollY - window.innerHeight + 20;
                window.scrollTo({ top: Math.max(0, Math.min(toSelects, toButton)), left: 0, behavior: "smooth" });
                return;
            }
            window.theme.scrollTo(theme.isMobile ? t - 30 : t - 20);
        }
        toggleCartBarOnScroll() {
            const t = window.scrollY;
            if (this.formWrapper) {
                const e = t > this.formWrapper.offsetTop + this.formWrapper.offsetHeight - 200;
                this.classList.toggle("is-visible", e);
            }
        }
        setCartBarHeight() {
            const t = this.offsetHeight;
            document.documentElement.style.setProperty("--cart-bar-height", `${t}px`);
        }
        disconnectedCallback() {
            this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
            this.observer && this.observer.disconnect();
            document.removeEventListener("theme:product:add-error", this.handleProductAddError),
                document.removeEventListener("theme:scroll", this.boundToggleCartBarOnScroll),
                document.removeEventListener("theme:resize", this.boundSetCartBarHeight);
        }
    }
    customElements.get("cart-bar") || customElements.define("cart-bar", t);
})();
